import { FormApi } from 'final-form';

import { AudienceSectionRefsContextValue } from './AudienceSectionRefsContext';
import { AudienceExpandedSectionsContextValue } from './AudienceExpandedSectionsContext';

import { DynamicAudienceSection, sectionToFormFieldsMap } from '../constants';
import { AudienceFormValues } from '../types';

export const getOpenAndScrollToInvalidSection =
  (
    sectionRefsContext: AudienceSectionRefsContextValue,
    expandedSectionsContext: AudienceExpandedSectionsContextValue,
  ) =>
  (form: FormApi<AudienceFormValues, Partial<AudienceFormValues>>) => {
    const { errors } = form.getState();

    const invalidSections: DynamicAudienceSection[] = [];

    Object.keys(sectionToFormFieldsMap).forEach((sectionName: DynamicAudienceSection) => {
      const fieldsInSection = sectionToFormFieldsMap[sectionName];

      const hasSectionErrors = fieldsInSection.some((fieldName) => errors?.[fieldName]);

      if (hasSectionErrors) {
        invalidSections.push(sectionName);
      }
    });

    if (invalidSections.length === 0) {
      return;
    }

    const expandedSectionsMap = invalidSections.reduce(
      (
        expandedMap: Partial<Record<DynamicAudienceSection, boolean>>,
        sectionKey: DynamicAudienceSection,
      ) => {
        return {
          ...expandedMap,
          [sectionKey]: true,
        };
      },
      {},
    );

    expandedSectionsContext.onMultipleExpandedChange(expandedSectionsMap);

    const isNameValid = !errors?.['name'];
    const isDescriptionValid = !errors?.['description'];

    if (isNameValid && isDescriptionValid) {
      const firstInvalidSectionKey = invalidSections[0];

      // we need to wait for all sections to be opened and only then scroll to the first invalid section
      setTimeout(() => {
        sectionRefsContext.audienceSectionsRef.current[firstInvalidSectionKey]?.scrollIntoView({
          behavior: 'smooth',
        });
      }, 300);
    }
  };
